import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router'
import { Sector } from '../models/Sector';
import { SectorService } from '../services/sector.service';
import { SectorDetalleService } from '../services/sector-detalle.service';

@Component({
  selector: 'app-sector-detail',
  templateUrl: './sector-detail.component.html',
  styleUrls: ['./sector-detail.component.css']
})
export class SectorDetailComponent implements OnInit {

  sectorId: string = '';
  sector: Sector;


  constructor(
    private router: ActivatedRoute,
    //definir el Service para obtener el detalle del Sector: "api/v1/sector/:id"
    private sectorDetalleService: SectorDetalleService
  ) { }

  ngOnInit() {
    console.log(this.router.snapshot.params);
    //this.sector=this.router.snapshot.params['id'];
    this.sectorId=this.router.snapshot.params.id;

    //------------------------------------------------------
    this.sectorDetalleService.getDetalleSector(this.router.snapshot.params.id)
      .subscribe((respone) => {
        this.sector = respone;
        console.log(respone);
      })
    
  }

}
